module.exports = __webpack_public_path__ + "img/AccountOnHold.14d3f18b.jpg";